const KatalifeInfoSection = () => {
    return (
        <section className="basic-area green-area">
            <div className="container">
                <div className="basic-flex progress" >
                    <div className="basic-flex__content">
                    <h2>
                        Katalife Free 
                    </h2>
                    <p> Unlock the full potential of your surveys with the following features of Katalife Free. Best for small teams, individuals, professionals, and small businesses.</p>
                    <ul className="show-bullets">
                        <li><strong>Predefined survey templates</strong> <br></br>Create surveys in minutes using our existing templates.</li>
                        <li><strong>Question banks</strong> <br/> Access a wide range of curated likert style questions to enhance your surveys.</li>
                        <li><strong>Easy feedback UI</strong> <br/> Our feedback UI is designed to be intuitive and user-friendly with an option for open-ended comment</li>
                        <li><strong>Progress Tracking</strong> <br/> Track your feedback over time to identify trends and areas for improvement.</li>
                        <li><strong>Mobile and Web App</strong> <br/> Track your feedback and progress anywhere using our mobile app or on the web.</li>
                        <li><strong>Custom Call to Action</strong> <br/> Customize what users see after submitting feedback, direct them to google rating or display a custom message.</li>
                        
                        
                        {/* <li>Customizable designs: Tailor the look and feel of your surveys to match your brand.</li> */}
                    </ul>
                    </div>
                    <img
                            className="basic-flex-phone-screenshot"
                            style={{ width: "300px", height: "600px" }}
                            src="images/katalife-democafe-feedback.png"
                            alt="activities"
                        />
                </div>                    
            </div>
        </section>
    );
};

export default KatalifeInfoSection;
